import React from 'react';
import { useUserAuth } from '../context/UserAuthContext';

interface TokenRefreshOverlayProps {
  children: React.ReactNode;
}

const overlayStyles: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const backdropStyles: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(2px)',
};

const contentStyles: React.CSSProperties = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  padding: '32px',
  background: 'white',
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  border: '1px solid #e5e7eb',
};

const spinnerContainerStyles: React.CSSProperties = {
  width: '48px',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const spinnerStyles: React.CSSProperties = {
  width: '32px',
  height: '32px',
  border: '3px solid #f3f4f6',
  borderTop: '3px solid #3b82f6',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const messageStyles: React.CSSProperties = {
  fontSize: '14px',
  color: '#6b7280',
  textAlign: 'center',
  fontWeight: '500',
};

const TokenRefreshOverlay: React.FC<TokenRefreshOverlayProps> = ({ children }) => {
  const { isTokenRefreshing } = useUserAuth();

  if (isTokenRefreshing) {
    return (
      <>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div style={overlayStyles}>
          <div style={backdropStyles} />
          <div style={contentStyles}>
            <div style={spinnerContainerStyles}>
              <div style={spinnerStyles}></div>
            </div>
            <div style={messageStyles}>
              토큰을 갱신하고 있습니다...
            </div>
          </div>
        </div>
      </>
    );
  }

  return <>{children}</>;
};

export default TokenRefreshOverlay;
